import { css } from '@emotion/react';
import { theme } from '../theme';
import { tokens } from '../tokens';
const ICON_SIZE = '12px';
const variantMap = {
    error: {
        backgroundColor: theme.white.main,
        iconColor: theme.error.main,
    },
    info: {
        backgroundColor: theme.white.main,
        iconColor: theme.info.darker,
    },
    success: {
        backgroundColor: theme.navy.main,
        iconColor: theme.success.main,
    },
    upgrade: {
        backgroundColor: 'transparent',
        iconColor: theme.upgrade.main,
    },
    warning: {
        backgroundColor: theme.navy.main,
        iconColor: theme.warning.lighter,
    },
};
const wrapperStaticStyle = css({
    alignItems: 'center',
    display: 'flex',
    flexShrink: 0,
    height: tokens.sizing.small,
    justifyContent: 'center',
    position: 'relative',
    width: tokens.sizing.small,
    zIndex: tokens.zIndex.default,
});
export function wrapperStyle({ isCentered }) {
    return [
        wrapperStaticStyle,
        isCentered &&
            css({
                marginLeft: 'auto',
            }),
    ];
}
const iconStaticStyle = css({
    alignItems: 'center',
    display: 'flex',
    height: '100%',
    justifyContent: 'center',
    left: 0,
    position: 'absolute',
    top: 0,
    width: '100%',
});
export function iconStyle({ variant }) {
    return [
        iconStaticStyle,
        css({
            // Obtain the accent color based on the icon variant
            color: variantMap[variant].iconColor,
        }),
    ];
}
export function backgroundStyle({ variant }) {
    const borderWidth = `${parseInt(ICON_SIZE, 10) / 2}px`;
    // Creative way to get triangle shape for warning
    return variant === 'warning'
        ? css({
            borderBottom: `${ICON_SIZE} solid ${variantMap[variant].backgroundColor}`,
            borderLeft: `${borderWidth} solid transparent`,
            borderRight: `${borderWidth} solid transparent`,
            height: 0,
            width: 0,
        })
        : css({
            backgroundColor: variantMap[variant].backgroundColor,
            borderRadius: tokens.borderRadius.circle,
            height: ICON_SIZE,
            width: ICON_SIZE,
        });
}
